import './Home.css';
import { Link} from 'react-router-dom';
import Header from '../components/Header';
import Button from '../components/Button';
import React from 'react';
import {useState} from 'react';
import {useCookies} from 'react-cookie'

function Home() {

    const [takeOrder, setTakeOrder] = useState(false);
    const [cookies, setCookie] = useCookies(['userRole']);

    return (
        <div>
            <Header />
            <div className='home-page'>
                {
                    !takeOrder ? <div>
                        <h3 className='homepage-maintext'>What do you want to do?</h3>
                        <div className='home-buttons'>
                            <Button buttonText='Take An Order' onClickFunction={() => setTakeOrder(true)} />
                            <Link to='/orders'>
                                <Button buttonText='View Orders' />
                            </Link>
                            {
                                cookies.userRole === 'admin' ? 
                                <Link to='/admin'>
                                    <Button buttonText='Admin Page' />
                                </Link> : null
                            }
                        </div>
                    </div> : <div>
                        <h3 className='homepage-maintext'>What kind of order is this?</h3>
                        <div className='home-buttons'>
                            <Link to='/takeorder' state={{orderType: 'dinein'}}>
                                <Button buttonText='Dine In' />
                            </Link>
                            <Link to='/takeorder' state={{orderType: 'takeout'}}>
                                <Button buttonText='Takeout' />
                            </Link>
                            <Link to='/takeorder' state={{orderType: 'drivethru'}}>
                                <Button buttonText='Drive Thru' />
                            </Link>
                        </div>
                    </div>
                }
                
            </div>
        </div>
    )
}

export default Home;